import { useCheckout } from '@stripe/react-stripe-js/checkout';
import { Input } from '@/components/ui/input';

// Validate email with checkout
const validateEmail = async (email: string, checkout: any) => {
  const updateResult = await checkout.updateEmail(email);
  const isValid = updateResult.type !== "error";
  return { isValid, message: !isValid ? updateResult.error.message : null };
};

interface EmailInputProps {
  email: string;
  setEmail: (email: string) => void;
  error: string | null;
  setError: (error: string | null) => void;
  onEmailValidated?: (email: string) => void;
}

export const EmailInput = ({
  email,
  setEmail,
  error,
  setError,
  onEmailValidated
}: EmailInputProps) => {
  const checkoutState = useCheckout();

  const handleBlur = async () => {
    if (!email) {
      return;
    }

    // Only validate if checkout is ready
    if (checkoutState.type !== 'loading' && checkoutState.type !== 'error' && 'checkout' in checkoutState) {
      const { isValid, message } = await validateEmail(email, checkoutState.checkout);
      if (!isValid) {
        setError(message);
        return;
      }

      // Notify parent component that email is validated
      if (isValid && onEmailValidated) {
        onEmailValidated(email);
      }
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setError(null);
    setEmail(e.target.value);
  };

  return (
    <div className="relative w-full mb-4">
      <div id="email-input-anchor" className="h-0 absolute -top-14 right-0"></div>
      <label htmlFor="email" className="block text-sm font-medium text-slate-700 mb-2">
        Email
      </label>
      <Input
        id="email"
        type="email"
        value={email}
        onChange={handleChange}
        onBlur={handleBlur}
        className={error ? 'border-red-300 text-base placeholder:text-slate-400' : 'text-base placeholder:text-slate-400'}
        placeholder="your@email.com"
      />
      {error && <div className="text-xs text-red-500 mt-1">{error}</div>}
    </div>
  );
};
